// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as MarkdownH3Extended } from '../../../../../ui-v3/src/assets/icons/extended/markdown/markdown-h3.svg?react';
import { createIcons } from '../../Icon';
const MarkdownH3Icon = /* @__PURE__ */ createIcons('MarkdownH3', {
    extended: MarkdownH3Extended
});
MarkdownH3Icon.supportedTypes = [
    'extended'
];
MarkdownH3Icon.category = 'markdown';
export default MarkdownH3Icon;
